export const AppConfig = {
	environment: process.env.ENVIRONMENT ?? 'local',
	isProduction: process.env.ENVIRONMENT === 'production',
	healthIndividualApiUrl: process.env.PUBLIC_HEALTH_INDIVIDUAL_API_URL ?? '',
	authApiUrl: process.env.PUBLIC_AUTH_API_URL ?? '',
	applePayMerchantID: process.env.PUBLIC_VALUE_APPLE_PAY_MERCHANT_ID,
	loginUrl: '/login',
	dashboardUrl: '/account',
	myPoliciesUrl: '/account/policies',
	notificationHistoryUrl: '/account/notifications',
	accountSettingsUrl: '/account/settings',
	termsAndConditionsUrl: '/terms-and-conditions',
	discountTermsAndConditionsUrl: '/offers/celebrate-uae-national-day-eid-al-etihad-with-shory',
	privacyPolicyUrl: '/privacy-policy',
	omniChannelConfig: {
		appId: process.env.PUBLIC_OMNICHANNEL_ID_EN ?? '',
		orgId: process.env.PUBLIC_OMNICHANNEL_ORG_ID ?? '',
		orgUrl: process.env.PUBLIC_OMNICHANNEL_ORG_URL ?? '',
		widgetId: process.env.PUBLIC_OMNICHANNEL_ID ?? '',
		appId_AR: process.env.PUBLIC_OMNICHANNEL_ID_AR ?? '',
	},
};
